module.exports = __webpack_public_path__ + "img/decorate2.7b6aaca9.png";